import { render, staticRenderFns } from "./CensusDashboardPane.vue?vue&type=template&id=96050990&scoped=true&"
import script from "./CensusDashboardPane.vue?vue&type=script&lang=js&"
export * from "./CensusDashboardPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96050990",
  null
  
)

export default component.exports